/**
 * Drag and Drop Utilities
 *
 * Helper functions for react-beautiful-dnd drag and drop interactions.
 *
 * NOTE: This utility currently just passes through the draggableStyle without modification.
 * It exists as a standardized interface for applying drag styles across components.
 * In the future, you could add custom styling logic here (e.g., opacity changes, scale transforms).
 *
 * @example
 * // Basic usage - applies default drag behavior from react-beautiful-dnd
 * <Draggable draggableId="item-1" index={0}>
 *   {(provided, snapshot) => (
 *     <div
 *       style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
 *     >
 *       Drag me!
 *     </div>
 *   )}
 * </Draggable>
 *
 * @example
 * // If you wanted to add custom styling in the future:
 * export const getItemStyle = (isDragging, draggableStyle) => ({
 *   ...draggableStyle,
 *   opacity: isDragging ? 0.5 : 1,
 *   transform: isDragging ? 'rotate(5deg)' : 'none',
 * });
 */

/**
 * Applies drag-and-drop styling to a draggable item.
 * Currently passes through react-beautiful-dnd's default styles unchanged.
 *
 * @param isDragging - Whether the item is currently being dragged (currently unused)
 * @param draggableStyle - Style object from react-beautiful-dnd (position, transform, etc.)
 * @returns Style object to apply to the draggable element
 */
export const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  ...draggableStyle,
});
